// templateStarters.js
// ─────────────────────────────────────────────────────────────────────────────
// Ready-made HTML starter templates. These are dropped into the Templates editor
// as a starting point and then tweaked per client. Tokens follow templateEngine:
//   {{field}}  {{check:field=value}}  {{date:field}}
//
// SITE_INSTRUCTION_HTML is a CLIENT-NEUTRAL generic Site Instruction form — a
// starting point. Drop in the client's logo (<img src="…">) in the logo slot,
// or better: use "Upload & auto-map (AI)" to turn the client's own document
// into a template automatically.
// ─────────────────────────────────────────────────────────────────────────────

export const SITE_INSTRUCTION_HTML = `
<style>
  .si-doc { font-family: Arial, Helvetica, sans-serif; color: #111; font-size: 11pt; }
  .si-doc .head { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #1f3a5f; padding-bottom: 8px; margin-bottom: 14px; }
  .si-doc .logo { font-size: 13pt; font-weight: 700; letter-spacing: .04em; color: #64748b; border: 1px dashed #94a3b8; padding: 8px 14px; border-radius: 6px; }
  .si-doc h1 { font-size: 16pt; margin: 0; text-transform: uppercase; letter-spacing: .06em; }
  .si-doc table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
  .si-doc td, .si-doc th { border: 1px solid #444; padding: 6px 8px; vertical-align: top; font-size: 10.5pt; }
  .si-doc .lbl { background: #f0f0f0; font-weight: 700; width: 220px; }
  .si-doc .opt { text-align: center; white-space: nowrap; }
  .si-doc .body { min-height: 90px; }
  .si-doc .foot { margin-top: 16px; font-size: 9.5pt; font-style: italic; color: #333; }
  @media print { .si-doc { font-size: 10.5pt; } }
</style>
<div class="si-doc">
  <div class="head">
    <!-- Replace with the client logo: <img src="..." style="height:54px"> -->
    <div class="logo">[ CLIENT LOGO ]</div>
    <h1>Site Instruction</h1>
  </div>

  <table>
    <tr><td class="lbl">Project Number</td><td>{{clientProjectNumber}}</td><td class="lbl">SI No.</td><td>{{siNumber}}</td></tr>
    <tr><td class="lbl">Contract number</td><td colspan="3">{{contractNumber}}</td></tr>
    <tr><td class="lbl">Contract description</td><td colspan="3">{{contractDescription}}</td></tr>
    <tr><td class="lbl">Contractor</td><td colspan="3">{{contractor}}</td></tr>
  </table>

  <table>
    <tr><td class="lbl">Subject</td><td>{{subject}}</td></tr>
    <tr><td class="lbl">Instruction</td><td class="body">{{instruction}}</td></tr>
    <tr><td class="lbl">Applicable Drawing / Revision</td><td>{{drawingRevisionRef}}</td></tr>
    <tr><td class="lbl">Applicable Pay Items</td><td>{{applicablePayItems}}</td></tr>
  </table>

  <table>
    <tr>
      <td class="lbl">As Built Implications</td>
      <td class="opt">Yes {{check:asBuiltImplications=Yes}}</td>
      <td class="opt">No {{check:asBuiltImplications=No}}</td>
      <td colspan="3"></td>
    </tr>
    <tr>
      <td class="lbl">Financial Implications</td>
      <td class="opt">Saving {{check:valuationBasis=Saving}}</td>
      <td class="opt">None {{check:valuationBasis=None}}</td>
      <td class="opt">Admeasure {{check:valuationBasis=Admeasure}}</td>
      <td class="opt">New Rates {{check:valuationBasis=New Rates}}</td>
      <td class="opt">Day Works {{check:valuationBasis=Day Works}}</td>
    </tr>
  </table>

  <table>
    <tr>
      <td class="lbl">Employer's Agent Representative</td><td>{{employersAgentRepresentative}}</td>
      <td class="lbl">Date</td><td>{{date:instructionDate}}</td>
      <td class="lbl">Time</td><td>{{instructionTime}}</td>
    </tr>
    <tr><td class="lbl">Contractor's Remarks</td><td colspan="5" class="body">{{contractorRemarks}}</td></tr>
    <tr>
      <td class="lbl">Instruction received by Contractor's Representative</td><td>{{receivedBy}}</td>
      <td class="lbl">Date</td><td>{{date:receivedDate}}</td>
      <td class="lbl">Time</td><td>{{receivedTime}}</td>
    </tr>
    <tr><td class="lbl">Distribution</td><td colspan="5">{{distribution}}</td></tr>
  </table>

  <p class="foot">Note: The valid version of this site instruction is a SIGNED copy.</p>
</div>
`.trim();

export const STARTERS = [
  {
    key: "generic-site-instruction",
    name: "Site Instruction (generic)",
    docType: "instruction",
    client: "",
    html: SITE_INSTRUCTION_HTML,
  },
];
